import { Avatar, ButtonBase, Stack, Typography } from '@mui/material';
import { ControlledAutocomplete } from 'Components/ControlledAutoComplete';
import { EntitlementsContext } from 'Context/CompassRightsContext/EntitlementsProvider';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PurpleSearchIcon, PurpleX } from 'Images';
import { useContext, useEffect, useState } from 'react';
import { sessionTextSearch } from 'reducer/CompassRights/EntitlementsReducer';

export const SearchEntitlement = () => {
  const isDesktop = useIsDesktop();
  const { dispatchEntitlements, entitlements } =
    useContext(EntitlementsContext);
  const [timeout, setTimeout] = useState<any>(null);
  const [inputValue, setInputValue] = useState('');
  const [activeSearch, setActiveSearch] = useState<boolean>(false);

  const dictionary = useDictionary(Dictionary, DICTIONARY.CompassRights);

  const submitSearch = (value: string) => {
    value.length > 0 ? setActiveSearch(true) : setActiveSearch(false);
    clearTimeout(timeout);
    const debounceID = window.setTimeout(() => {
      dispatchEntitlements({
        type: 'SEARCH_ENTITLEMENT',
        payload: { value: value },
      });
    }, 500);

    setTimeout(debounceID);
  };
  useEffect(() => {
    const textSearch = sessionStorage.getItem(sessionTextSearch);
    if (textSearch) {
      setActiveSearch(true);
      setInputValue(textSearch);
    }
  }, []);

  const resetSearchResults = () => {
    setInputValue('');
    dispatchEntitlements({
      type: 'SEARCH_ENTITLEMENT',
      payload: { value: '' },
    });
  };

  const options = [
    ...new Set(
      entitlements.allEntitlements
        .filter(
          (entitlement) =>
            entitlement.name?.includes(inputValue) ||
            entitlement.description?.includes(inputValue)
        )
        .map((entitlement) => entitlement.name)
    ),
  ];

  return (
    <ControlledAutocomplete
      freeSolo
      label={dictionary.search}
      options={options}
      setValue={(value: string | null) => {
        submitSearch(value ?? '');
      }}
      inputValue={inputValue}
      inputLabelProps={{
        shrink: false,
        sx: { display: inputValue?.length > 0 ? 'none' : 'block' },
      }}
      setInputValue={(value) => setInputValue(value)}
      paperComponent={
        options.length === 0 && (
          <Typography variant={'body3'}>
            {dictionary.noSearchResults}
          </Typography>
        )
      }
      paperSx={{
        mt: '1px',
        ml: '10px',
        width: isDesktop ? '425px' : '93%',
      }}
      style={{
        borderRadius: '34px',
        border: '1px solid',
        borderColor: 'primary.shade_200',

        '&&& .MuiOutlinedInput-notchedOutline': {
          borderRadius: '34px',
          bgcolor: '#fff',
          zIndex: -1,
          borderColor: 'primary.shade_200',
          borderWidth: '1px',
        },
        '&&& .MuiInputBase-root input[dropdown="open"] ~ fieldset': {
          borderColor: 'transparent',
        },
      }}
      disableClearIcon
      endAdornment={
        <Stack
          direction={'row'}
          marginRight={'5px'}
          width={'auto'}
          gap={'15px'}
        >
          {inputValue.length > 0 && (
            <ButtonBase onClick={resetSearchResults}>
              <Avatar
                src={PurpleX}
                alt={''}
                sx={{ width: '20px', height: '20px' }}
              />
            </ButtonBase>
          )}
          <Avatar
            src={PurpleSearchIcon}
            alt=''
            sx={{
              width: isDesktop ? '37px' : '31px',
              height: isDesktop ? '37px' : '31px',
              mr: isDesktop ? '-4px' : '-6px',
            }}
          />
        </Stack>
      }
    />
  );
};
